export default __webpack_public_path__ + "static/media/pink-pattern.f0789d64d2dded482a6c419bf4058bce.png";